<template>
  <div class="home">
    <a-row class="home-head">
      <a-col :span="24">
        <p>
          全部队员
          <a class="total-btn" @click="returnBtn">
            <font style="margin-right: 6px;">&lt;</font>返回
          </a>
        </p>
        <!-- <a class="add-team-btn" @click="addTeam">添加队员</a> -->
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <div class="allteam-top">
          <div>
            <img
              @click="activeHideAll"
              class="selected-img"
              id="selecte-all"
              src="../assets/images/selected-img.png"
            />
            <input type="checkbox" class="active-all" @click="activeAll" />
          </div>
          <ul class="team-top">
            <li
              @click="getGroup(index,item)"
              :class="{selected : groupIndex == index}"
              v-for="(item,index) in group"
              :key="index"
            >{{item.GroupName}}</li>
            <a class="add-team-btn" @click="addTeam">添加队员</a>
          </ul>
          <img
            class="delete-team-btn delete-team-btn-total"
            @click="deleteTeam"
            src="../assets/images/modeling_btn_delete.png"
            alt
          />
        </div>
        <ul class="team-list" @touchstart="touchSatrt" @touchmove="touchMove" @touchend="touchEnd">
          <li
            v-for="(item,index) in teamList.data"
            :class="{offLine : item.Name=='S'}"
            :key="index"
          >
            <img
              @click="activeHide"
              :index="item.ID"
              class="selected-img"
              id="selecte"
              src="../assets/images/selected-img.png"
            />
            <input
              class="check-box"
              :index="item.ID"
              :disabled="item.Name=='S'"
              :class="{disable : item.Name=='S'}"
              :value="item.ID"
              v-model="checkedId"
              type="checkbox"
              @click="active"
            />
            <img src="../assets/images/icon_teammate.png" v-if="item.Name!='S'" />
            <img src="../assets/images/icon_teammate_offline.png" v-else />
            <span>{{item.Name}}</span>
            <span>{{item.NO}}</span>
            {{item.SN}}
            <img
              class="update-team-btn"
              @click="updateTeam(item)"
              src="../assets/images/modeling_img_tzjmOn.png"
            />
            <img
              class="delete-team-btn"
              style="margin: 0 -35px 0 30px;"
              @click="deleteTeam($event,item.ID)"
              src="../assets/images/modeling_btn_delete.png"
              alt
            />
          </li>
        </ul>
      </a-col>
      <div style="width:100%;height:100%;background:#576371;position: absolute; display:flex;" v-show="loadAllTeamImg">
        <img src="../assets/load-img.gif" style="width:10%;display: block; margin: auto;">
      </div>
    </a-row>

    <transition name="fade">
      <div class="team-box" v-if="teamInfoBox">
        <h1>
          {{teamBoxTitie}}
          <span @click="closeBox">×</span>
        </h1>
        <input type="text" placeholder="请输入队员编号" v-model="NO" @change="setTeam" />
        <input type="text" placeholder="请输入队员姓名" v-model="name" @change="setTeam" />
        <input
          type="text"
          :disabled="!showAdd"
          placeholder="请输入组别"
          v-model="groupName"
          @change="setTeam"
        />
        <input
          type="text"
          maxlength="11"
          :disabled="!showAdd"
          placeholder="请输入设备SN号"
          v-model="SN"
          @change="setTeam"
        />
        <div>
          <button @click="saveAdd" v-if="showAdd">
            继续添加
            <strong id="add-load"></strong>
          </button>
          <button @click="save">
            保存并关闭
            <strong id="save-load"></strong>
          </button>
        </div>
      </div>
    </transition>
    <div
      style="width:100%;height:100%;position: fixed;background: #000;opacity: .2;z-index: 0;top:0;left:8vw"
      v-if="teamInfoBox"
    ></div>

    <transition name="fade">
      <div class="team-box-del" v-show="delBox">
        <h4>
          提示
          <!--<span @click="closeBox">×</span>-->
        </h4>
        <p>
          删除后将不在保留队员信息
          <br />是否确定删除
        </p>
        <div>
          <button @click="delCancal">取消</button>
          <button @click="delSave">确定<strong id="del-load"></strong></button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import AllTeamService from "../api/AllTeamService";
import { Modal } from "ant-design-vue";
export default {
  inject: ["reload"],
  data() {
    return {
      groupIndex: 0,
      group: [],
      teamList: [],
      name: "",
      NO: "",
      groupName: "",
      SN: "",
      teamId: "",
      troopsID: "", 
      teamInfoBox: false,
      teamBoxTitie: "",
      showAdd: true,
      checkedId: [],
      delBox: false,
      startX:0,
      startY:0,
      endX:0,
      endY:0,
      currentGroupIndex:0,
      loadAllTeamImg:true
    };
  },
  created() {},
  mounted() {  
    this.getAllTeamList();

    sessionStorage.setItem("isAllTeam", true);
    let teamInfo = sessionStorage.getItem("teamInfo");
    if (teamInfo != null && teamInfo != "") {
      let teamInfoObj = JSON.parse(teamInfo)
      this.teamInfoBox = teamInfoObj.teamInfoBox
      this.teamBoxTitie = teamInfoObj.teamBoxTitie
      this.showAdd = this.teamBoxTitie == '添加队员' ? true : false
      this.teamId = teamInfoObj.teamId
      this.troopsID = teamInfoObj.TroopsID
      this.name = teamInfoObj.name
      this.NO = teamInfoObj.NO
      this.groupName = teamInfoObj.groupName
      this.SN = teamInfoObj.SN
    }
  },
  methods: {
    touchSatrt(e){
      let touch=e.touches[0]  
      this.startX = touch.pageX           
      this.startY = touch.pageY 
    },
    touchMove(e){
      let touch = e.touches[0]             
      this.endX = this.startX - touch.pageX 
      this.endY = this.startY - touch.pageY    
    },
    touchEnd(){ 
      if(this.endX < -20 && this.endY < 30){
        if(this.currentGroupIndex>0){
          this.currentGroupIndex--
          this.getGroup(this.currentGroupIndex,this.group[this.currentGroupIndex])
        } 
      }else if(this.endX > 20 && this.endY < 30){
        if(this.currentGroupIndex<this.group.length-1){
          this.currentGroupIndex++ 
          this.getGroup(this.currentGroupIndex,this.group[this.currentGroupIndex])
        } 
      }
    },
    getAllTeamList(isAdd,upSN) {
      AllTeamService.getAllTeamList().then(
        res => {
          if (res.status == 200 && res.data.status == 1000) {
            let data = res.data.data;
            this.loadAllTeamImg=false
            this.$store.commit("setAllTeamMember", data)
            

            if (isAdd=='add') {
              if(this.$store.state.TeamMemberLists==null){
                this.$store.commit("setTeamMemberLists", res.data.data)
              }else{
                this.$store.commit(
                  "setTeamMemberListsByAdd",
                  data[data.length - 1]
                );
              } 
            }else if(isAdd=='update'){
              for (var i = 0; i < data.length; i++) {
                if(data[i].SN == upSN){
                  this.$store.commit("setTeamMemberListsBySN",  data[i])
                }
              }
              
            }





            let tempArr = [];
            let dataArr = [];
            if (data != null || data != undefined) {
              for (let i = 0; i < data.length; i++) {
                if (tempArr.indexOf(data[i].GroupName) == "-1") {
                  tempArr.push(data[i].GroupName);
                  var tempObj = {};
                  tempObj.GroupName = data[i].GroupName;
                  tempObj.data = [data[i]];
                  dataArr.push(tempObj);
                } else {
                  for (let j = 0; j < dataArr.length; j++) {
                    if (dataArr[j].GroupName == data[i].GroupName) {
                      dataArr[j].data.push(data[i]);
                    }
                  }
                }
                this.group = dataArr   
                this.teamList = dataArr[this.groupIndex]
              }
            }
          } else if (res.status == 200) {
            this.$message.warning(res.data.msg);
          } else {
            this.$message.warning(res.message);
          }
        },
        err => {
          if (err && err.stack.indexOf('timeout') > -1) {
            this.$message.warning('连接超时,正在重新连接')
            this.getAllTeamList()
          }else{
            this.$message.warning(err.message)
          } 
        }
      );
    },
    delMask() {
      var mask = document.getElementById("mask");
      if (mask != null) {
        mask.parentNode.removeChild(mask);
      }
    },
    addMask() {
      var div = document.createElement("div");
      div.id = "mask";
      document.body.appendChild(div);
    },
    closeBox() {
      sessionStorage.setItem("teamInfo", ""); 
      this.teamInfoBox = false;   
    },
    returnBtn() {
      sessionStorage.removeItem("isAllTeam");
      //this.$router.go(-1)
      this.$router.push({
        name: "teams"
      }).catch(err => {console.error(err)});
    },
    getGroup(index, item) { 
      this.currentGroupIndex=index
      this.checkedId = [];
      document.getElementsByClassName(
        "active-all"
      )[0].previousElementSibling.style.display = "none";
      for (
        let i = 0;
        i < document.getElementsByClassName("check-box").length;
        i++
      ) {
        document.getElementsByClassName("check-box")[
          i
        ].previousElementSibling.style.display = "none";
        document.getElementsByClassName("check-box")[i].checked = false;
      }

      this.groupIndex = index; 
      this.teamList = item;
      document.getElementsByClassName("active-all")[0].checked = false;
      for (
        let i = 0;
        i < document.getElementsByClassName("check-box").length;
        i++
      ) {
        document.getElementsByClassName("check-box")[i].checked = false;
      }
    },
    active(e) {
      if (!e.target.checked) {
        e.target.previousElementSibling.style.display = "none";
        e.target.checked = false;
      } else {
        e.target.previousElementSibling.style.display = "block";
        e.target.checked = true;
      }
      let checkEle = document.getElementsByClassName("check-box");
      let count = 0;
      let dCounst = 0;
      for (var i = 0; i < checkEle.length; i++) {
        if (checkEle[i].getAttribute("disabled") == null) {
          dCounst++;
        }
        if (checkEle[i].checked) {
          count++;
        }
      }
      if (count == dCounst) {
        document.getElementById("selecte-all").style.display = "block";
      } else {
        document.getElementById("selecte-all").style.display = "none";
      }
    },
    activeHide(e) {
      document.getElementById("selecte-all").style.display = "none";
      document.getElementsByClassName("active-all")[0].checked = false;
      e.target.style.display = "none";
      for (var i = 0; i < this.checkedId.length; i++) {
        if (this.checkedId[i] == e.target.getAttribute("index")) {
          this.checkedId.splice(i, 1);
        }
      }
      e.target.nextElementSibling.checked = false;
    },
    activeAll(e) {
      let checkEle = document.getElementsByClassName("check-box");
      for (var i = 0; i < checkEle.length; i++) {
        if (checkEle[i].checked == false) {
          checkEle[i].click();
        }
      }
    },
    activeHideAll(e) {
      e.target.style.display = "none";
      e.target.nextElementSibling.checked = false;
      for (
        var i = 0;
        i < document.getElementsByClassName("check-box").length;
        i++
      ) {
        document.getElementsByClassName("check-box")[
          i
        ].previousElementSibling.style.display = "none";
        document.getElementsByClassName("check-box")[i].checked = false;
      }
      this.checkedId = [];
    },
    addTeam() {
      this.teamInfoBox = true;
      this.teamBoxTitie = "添加队员";
      this.showAdd = true;
      this.name = "";
      this.NO = "";
      this.groupName = "";
      this.SN = "";
      //this.addMask()
    },
    setTeam() { 
      let teamInfo = {
        teamId:this.teamId,
        teamInfoBox: true,
        teamBoxTitie: this.teamBoxTitie,
        name: this.name,
        NO: this.NO,
        groupName: this.groupName,
        SN: this.SN,
        troopsID:this.troopsID
      };
      sessionStorage.setItem("teamInfo", JSON.stringify(teamInfo));
    },
    updateTeam(item) {
      this.teamId = item.ID;
      this.teamInfoBox = true;
      this.teamBoxTitie = "修改队员信息";
      this.showAdd = false;
      this.name = item.Name;
      this.NO = item.NO;
      this.groupName = item.GroupName;
      this.SN = item.SN;
      this.troopsID = item.TroopsID;
      //this.addMask()
    },
    checkData() {
      let regName = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5]+$");
      let regNO = new RegExp("^[A-Za-z0-9]+$");
      if (
        this.name.replace(/\([^\)]*\)$/g, "") == "" ||
        this.name.replace(/\([^\)]*\)$/g, "").length > 5 ||
        !regName.test(this.name.replace(/\([^\)]*\)$/g, ""))
      ) {
        this.$error({
          title: "提示",
          content:
            "请输入合法的队员姓名,只能输入汉字字母数字,长度不能超过5个字符",
          okText: "确定",
          centered: true
        });
      } else if (
        this.NO.replace(/\([^\)]*\)$/g, "") == "" ||
        this.NO.replace(/\([^\)]*\)$/g, "").length > 11 ||
        !regNO.test(this.NO.replace(/\([^\)]*\)$/g, ""))
      ) {
        this.$error({
          title: "提示",
          content:
            "请输入合法的队员编号，只能输入字母数字,长度不能超过11个字符",
          okText: "确定",
          centered: true
        });
      } else if (this.groupName == "" || this.groupName.length > 5) {
        this.$error({
          title: "提示",
          content: "请输入正确的组别,长度不能超过6个字符",
          okText: "确定",
          centered: true
        });
      } else if (this.SN.length != 11 || this.SN.substring(0, 1) != "S") {
        this.$error({
          title: "提示",
          content: "请输入合法的设备SN号,首字符为S,共11位",
          okText: "确定",
          centered: true
        });
      } else {
        return true;
      }
      return false;
    },
    addLoad() {
      for (var i = 0; i < this.group.length; i++) {
        if (this.group[i].GroupName == this.groupName) {
          this.group[i].data.push({
            GroupName: this.groupName,
            NO: this.NO,
            Name: this.name,
            SN: this.SN
          });
          return true;
        } else {
          return false;
        }
      }
    },
    save(e) {
      if (this.showAdd) {
        if (this.checkData()) {
          e.target.setAttribute("disabled", "true");
          //let loadIcon = document.createElement('s')
          //e.target.appendChild(loadIcon)
          document.getElementById("save-load").style.display = "inline-block";
          let paramObj = {
            Name: this.name,
            NO: this.NO,
            GroupName: this.groupName,
            SN: this.SN
          }; 
          AllTeamService.AddAllTeam(paramObj).then(
            res => {
              if (res.status == 200 && res.data.status == 1000) {
                sessionStorage.setItem("teamInfo", "");
                document.getElementById("save-load").style.display = "none";
                this.$message.success("添加成功"); 
                this.delMask();
                this.getAllTeamList('add');
                //this.groupIndex=0
                this.teamInfoBox =false
                //this.reload();
              } else if (res.status == 200) {
                document.getElementById("save-load").style.display = "none";
                this.$message.warning(res.data.msg);
                e.target.removeAttribute("disabled");
              } else {
                document.getElementById("save-load").style.display = "none";
                this.$message.warning(res.message);
                e.target.removeAttribute("disabled");
              }
            },
            err => {
              document.getElementById("save-load").style.display = "none";
              this.$message.warning(err.message);
              e.target.removeAttribute("disabled");
            }
          );
        }
      } else {
        if (this.checkData()) {
          let paramObj = {
            ID: this.teamId,
            troopsID: this.troopsID,
            Name: this.name,
            NO: this.NO,
            GroupName: this.groupName,
            SN: this.SN
          };
          document.getElementById("save-load").style.display = "inline-block"
          AllTeamService.UpdateAllTeam(paramObj).then(
            res => {
              if (res.status == 200 && res.data.status == 1000) {

                this.getAllTeamList('update',paramObj.SN)
                sessionStorage.setItem("teamInfo", ""); 
                document.getElementById("save-load").style.display = "none"
                this.$message.success("修改成功"); 
                this.delMask();
                //this.groupIndex=0
                this.teamInfoBox =false
                //this.reload();
              } else if (res.status == 200) {
                document.getElementById("save-load").style.display = "none"
                this.$message.warning(res.data.msg);
              } else {
                document.getElementById("save-load").style.display = "none"
                this.$message.warning(res.message);
              }
            },
            err => {
              document.getElementById("save-load").style.display = "none"
              this.$message.warning(err.message);
            }
          );
        }
      }
    },
    saveAdd() {
      if (this.checkData()) {
        let paramObj = {
          Name: this.name,
          NO: this.NO,
          GroupName: this.groupName,
          SN: this.SN
        }; 

        document.getElementById("add-load").style.display = "inline-block"; 
        AllTeamService.AddAllTeam(paramObj).then(
          res => {
            if (res.status == 200) {
              if (res.data.status == 1000) {
                //console.log(new Date())
                document.getElementById("add-load").style.display = "none";
                this.$message.success("添加成功");
                if (!isNaN(this.NO[this.NO.length - 1])) {
                  if (this.NO[this.NO.length - 1] == 9) {
                    if (isNaN(this.NO[this.NO.length - 2])) {
                      this.NO = this.NO.substring(0, this.NO.length - 1) + "10";
                    } else {
                      this.NO =
                        this.NO.substring(0, this.NO.length - 2) +
                        (parseInt(this.NO[this.NO.length - 2]) + 1) +
                        "0";
                    }
                  } else {
                    this.NO =
                      this.NO.substring(0, this.NO.length - 1) +
                      (parseInt(this.NO[this.NO.length - 1]) + 1);
                  }
                }
                this.SN = this.SN.substring(0, this.SN.length - 3);

                this.getAllTeamList('add');
              } else {
                document.getElementById("add-load").style.display = "none";
                this.$message.warning(res.data.msg);
              }
            } else {
              document.getElementById("add-load").style.display = "none";
              this.$message.warning(res.message);
            }
          },
          err => {
            document.getElementById("add-load").style.display = "none";
            this.$message.warning(err.message);
          }
        );
      }
    },
    deleteTeam(e, id) {
      if (id == undefined || id == null) {
        if (this.checkedId.length == 0) {
          this.$error({
            title: "提示",
            content: "请选择数据...",
            okText: "确定",
            centered: true
          });
        } else {
          this.delBox = true;
          this.addMask();
        }
      } else {
        let that = this;
        this.$confirm({
          title: "提示",
          content: "是否删除",
          centered: true,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            AllTeamService.DeleteTeam({ id: id }).then(
              res => {
                if (res.status == 1000) {
                  for (var i = 0; i < that.TeamMemberLists.length; i++) {
                    if (that.TeamMemberLists[i].ID == id) {
                      that.TeamMemberLists.splice(i, 1);
                    }
                  }
                  that.$message.success("删除成功");
                  that.reload();
                } else {
                  that.$message.warning(res.data.msg);
                }
              },
              err => {
                that.$message.warning(err.message);
              }
            );
          }
        });
      }
    },
    delCancal() {
      this.delBox = false;
      this.delMask();
    },
    delSave() {
      document.getElementById("del-load").style.display = "inline-block"
      AllTeamService.DeleteAllTeam({ ids: this.checkedId.join() }).then(
        res => {
          if (res.status == 1000) {
            for (var i = 0; i < this.TeamMemberLists.length; i++) {
              for (var j = 0; j < this.checkedId.length; j++) {
                if (this.TeamMemberLists[i].ID == this.checkedId[j]) {
                  this.TeamMemberLists.splice(i, 1);
                }
              }
            }
            document.getElementById("del-load").style.display = "inline-block"
            this.$message.success("删除成功");
            this.delMask();
            this.reload();
          } else {
            document.getElementById("del-load").style.display = "inline-block"
            this.$message.warning(res.msg | "删除失败");
          }
        },
        err => {
          document.getElementById("del-load").style.display = "inline-block"
          this.$message.warning(err.message | "删除失败");
        }
      );
    }
  },
  computed: {
    TeamMemberLists() {
      return this.$store.state.TeamMemberLists;
    }
  }
};
</script>
<style lang="less" scoped>
.fade-enter-active {
  animation: bounce-in 0.4s;
}
.fade-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.offLine {
  color: #3f4650 !important;
}
.team-box {
  width: 560px;
  height: 530px;
  border-radius: 10px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  margin-left: -280px;
  margin-top: -265px;
  text-align: center;
  p {
    font-size: 20px;
    padding: 20px 0;
  }
  h1 {
    background: #40dc23;
    line-height: 70px;
    text-align: center;
    margin-bottom: 16px;
    color: #fff;
    border-radius: 10px 10px 0 0;
    position: relative;
    span {
      position: absolute;
      right: 10px;
      top: -5px;
      font-size: 40px;
      cursor: pointer;
    }
  }
  input {
    width: 70%;
    height: 60px;
    background: #dddce2;
    border: 0;
    text-align: center;
    font-size: 20px;
    margin: 10px auto;
  }
  button {
    cursor: pointer;
    background: #40dc23;
    line-height: 60px;
    text-align: center;
    color: #fff;
    border: 0;
    border-radius: 10px;
    font-size: 20px;
    width: 140px;
    margin: 16px 55px;
  }
  
}
strong {
    display: none;
    width: 22px;
    height: 22px;
    border: 3px solid #fff;
    border-right: 0;
    border-radius: 50%;
    margin-bottom: -3px;
    animation: myfirst 0.5s linear infinite;
  }
@keyframes myfirst {
  0% {
    transition: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.team-box-del {
  position: fixed;
  width: 340px;
  height: 240px;
  left: 50%;
  top: 50%;
  margin: -170px 0 0 -120px;
  border-radius: 10px;
  background: #fff;
  z-index: 1;
  text-align: center;
  font-size: 18px;
  h4 {
    font-size: 20px;
    font-weight: 600;
    padding: 20px 0;
  }
  p {
    height: 42px;
  }
  button {
    cursor: pointer;
    background: #40dc23;
    line-height: 50px;
    text-align: center;
    color: #fff;
    border: 0;
    margin-top: 30px;
    border-radius: 5px;
    font-size: 20px;
    width: 120px;
  }
  button:first-child {
    background: #fff;
    border: 1px solid #40dc23;
    color: #40dc23;
    margin-right: 60px;
  }
}
.add-team-btn {
  background: #40dc23;
  padding: 2px 20px;
  font-size: 16px;
  color: #fff;
  border-radius: 15px;
  float: left;
  margin: 15px 0 0 45px;
}
.delete-team-btn {
  position: absolute;
  right: 67px;
  top: 18px;
  cursor: pointer;
}
.update-team-btn {
  position: absolute;
  right: 52px;
  top: 18px;
  cursor: pointer;
}
.allteam-top {
  div {
    float: left;
    width: 59px;
    input {
      margin: 18px 0 0 25px;
      width: 20px;
      height: 20px;
      border: 0;
    }
    input:before {
      content: "";
      display: block;
      width: 21px;
      height: 21px;
      background: #eee;
      border-radius: 4px;
      position: absolute;
      left: 24px;
      top: 17px;
    }
    .selected-img {
      display: none;
      width: 22px;
      position: absolute;
      left: 24px;
      top: 17px;
      z-index: 1;
    }
  }
}

.selected {
  border-bottom: 4px solid #2c9918;
  color: #2c9918 !important;
}
.total-btn {
  float: right;
  display: block;
  width: 95px;
  height: 30px;
  line-height: 30px;
  margin-right: 30px;
  margin-top: 20px;
  background: #40dc23;
  border-radius: 20px;
  font-size: 18px;
  color: #fff;
  text-align: center;
}
.home-head {
    font-size: 36px;
    color: #fff; 
}
.team-major {
  border-right: 1px solid #14161a;
  li {
    border-top: 1px solid #575b64;
    padding: 0 26px;
    line-height: 60px;
    background: #2d313a;
    font-size: 20px;
    color: #fff;
    font {
      padding-right: 30px;
    }
    button {
      background: #5f666e;
      padding: 0px 10px;
      border: 0;
      border-radius: 15px;
      line-height: 23px;
      font-size: 14px;
      float: right;
      margin-top: 19px;
      cursor: pointer;
    }
  }
}
.team-top {
  height: 61px;
  background: #2d313a;
  border-top: 1px solid #575b64;
  li {
    cursor: pointer;
    float: left;
    line-height: 56px;
    font-size: 20px;
    color: #fff;
    padding: 0 20px;
    margin: 0 12px;
  }
}
.team-list {
  height: 86vh;
  overflow-y: auto;
  li {
    position: relative;
    padding: 0 25px;
    line-height: 60px;
    border-bottom: 1px solid #7a8694;
    font-size: 20px;
    color: #fff;
    span {
      display: inline-block;
      width: 166px;
    }
    input {
      width: 20px;
      height: 20px;
      border: 0;
    }
    input:before {
      content: "";
      display: block;
      width: 21px;
      height: 21px;
      background: #eee;
      border-radius: 4px;
      position: absolute;
      left: 24px;
      top: 17px;
    }
    .disable:before {
      background: #7f8b97;
    }
    img {
      width: 22px;
      margin: 0 15px 0 30px;
    }
    .selected-img {
      position: absolute;
      left: -6px;
      top: 17px;
      z-index: 1;
      display: none;
    }
  }
}

.team-box {
  s {
    display: inline-block;
    border: 4px solid red;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    margin: 0 0 -4px 3px;
  }
}
</style>

